import { render, staticRenderFns } from "./Courseinformation.vue?vue&type=template&id=5995297f&scoped=true&"
import script from "./Courseinformation.vue?vue&type=script&lang=js&"
export * from "./Courseinformation.vue?vue&type=script&lang=js&"
import style0 from "./Courseinformation.vue?vue&type=style&index=0&id=5995297f&scoped=true&lang=css&"
import style1 from "./Courseinformation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5995297f",
  null
  
)

export default component.exports